<template>
    <v-footer app pa-0 ma-0 style="z-index:2" class="pa-0">
      <v-container fluid pa-0 ma-0>
        <v-row
          no-gutters
          class="footer-row"
        >
          <v-col
            cols="4"
            md="6"
            align-self="center"
          >
            <v-row justify="end" class="pr-4 version-footer" >
              <div class="version">{{version}}  &copy; {{ new Date().getFullYear() }}</div>
            </v-row>
          </v-col>
          <v-col cols="3" md="1" class="text-center ml-2" align-self="center">
            <v-img
              src="../../assets/imgs/ultraip.png"
              width="105px"
              class="img-pol-size d-inline-flex mr-4"
            ></v-img>
          </v-col>
          <v-col cols="3" md="1" class="text-center" align-self="center">
            <v-img
              v-bind:src="($config.VUE_APP_CLIENT_BASED_CONFIG.logo)?$config.VUE_APP_CLIENT_BASED_CONFIG.logo:''"
              width="105px"
              class="img-pol-size d-inline-flex mr-4"
            ></v-img>
          </v-col>
        </v-row>
        
      </v-container>
    </v-footer>
</template>
<script>
  export default {
    name: 'CoreFooter',
    data () {
      return {
        about:false,
        aboutText: [],
        aboutKey:0
      }
    },
    computed:{
      version: {
        get() {
          const version = require('../../../version.json')
          return version.version
        }
      },
      aboutWidth:{
        get(){
          switch (this.$vuetify.breakpoint.name) {
            case 'xs': return "100%"
            case 'sm': return "80%"
            case 'md': return "50%"
            default: return "35%"
            
          }
        }
      }
    },
    methods:{
      async triggerAbout(){
        await this.$extractions.about().then(response=>{
          this.aboutText = response.data
          this.about = true
          this.aboutKey ++
        })
        
      }
    }
  }
</script>
<style>
  .v-footer{
    background-color: #f5f5f5!important;
    height: 70px!important;
    position: fixed;
    bottom: 20px;
    display: block;
  }
  .footer-row{
    justify-content: end!important;
  }
  .version-footer .row{
    justify-content: flex-end!important;
    margin-right: 10px!important;
  }
  @media (max-width: 700px) {
    .btn-size{
      font-size: 10px!important;
    }
    .img-ip-size{
      width: 70px!important;
    }
    .img-pol-size{
      width: 90px!important;
    }
    .version{
      font-size: 14px!important;
    }
  }
  @media (max-width: 620px) {
    .v-dialog{
      width: 80%!important;
    }
    .row.footer-row{
      justify-content: center!important;
    }
  }
  @media (max-width: 400px) {
    .version{
      font-size: 13px!important;
      text-align: center;
    }
  }
  @media (max-width: 300px) {
    .version{
      font-size: 11px!important;
    }
  }
</style>
